import React from 'react'
import './UpdateStatus.css';
import checkIcons from "../../../image/checkIcons.png";
import { useNavigate } from 'react-router-dom';
export default function UpdatedSuccessfully() {
    const navigate = useNavigate();
    return (
        <div>     <div className="updated-container-sucess">
            <div className="status-img-container">
                <div className="status-img-icon">
                    <img src={checkIcons} alt="status" />
                </div>
                <p className="status-updated-message">Status Updated Successfully!</p>
                <button
                    className="button-status"
                    onClick={() => navigate('/emailSearch')}
                >
                    Back To Home
                </button>
            </div>
        </div></div>
    )
}
